import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
	{
		path: '/:query',
		props: true,
		name: 'userPlan',
		component: () => import('../views/UserPlan')
	},
	{
		path: '/panel/',
		props: false,
		name: 'Admin',
		meta: {
			auth: true
		},
		component: () => import('../views/admin/index'),
		children: [
			{
				path: 'sessions',
				name: 'sessionsList',
				component: () => import('../views/admin/sessions')
			},
			{
				path: 'sessions-action/:id',
				props: true,
				name: 'sessionAction',
				component: () => import('../views/admin/sessions-action')
			},
			{
				path: 'sections',
				name: 'sectionsList',
				component: () => import('../views/admin/sections')
			},
			{
				path: 'section-action/:id',
				props: true,
				name: 'sectionAction',
				component: () => import('../views/admin/section-action')
			},
			{
				path: 'plans',
				name: 'plansList',
				component: () => import('../views/admin/plans')
			},
			{
				path: 'plan-action/:id',
				props: true,
				name: 'planAction',
				component: () => import('../views/admin/plan-action')
			},
			{
				path: 'import',
				props: true,
				name: 'import',
				component: () => import('../views/admin/import')
			},
		]
	},
	{
		path: '/s/404',
		name: 'Problem',
		component: () => import('../views/problems'),
	},
	{
		path: '/panel/login',
		name: 'Problem',
		component: () => import('../views/admin/login'),
	},
	{
		path: '*',
		redirect: '/s/404'
	}
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

export default router
